import { RoleV2ByMerchantFacade } from '@goparrot/users-v2-sdk';
import { getConfig, getInterceptors } from '@goparrot-dashboard-api/shared';

export const roleV2ByMerchantFacade = new RoleV2ByMerchantFacade(getConfig('api/v2/users-v2'), getInterceptors());
